// Hook para obtener traducciones del contenido dinámico de una propiedad
// Solo actúa cuando el idioma no es español Y la propiedad tiene traducciones habilitadas

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const usePropertyTranslations = (propertyId, enabled = false) => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.split('-')[0]; // 'en', 'es', 'fr'

  const [translations, setTranslations] = useState(null);
  const [loadingTranslations, setLoadingTranslations] = useState(false);

  useEffect(() => {
    if (!propertyId || !enabled) {
      if (lang !== 'es') i18n.changeLanguage('es');
      setTranslations(null);
      return;
    }

    if (lang === 'es') {
      setTranslations(null);
      return;
    }

    setLoadingTranslations(true);

    fetch(`/api/translate?propertyId=${propertyId}&lang=${lang}`)
      .then(res => res.json())
      .then(data => setTranslations(data))
      .catch(err => {
        console.error('[usePropertyTranslations] Error:', err);
        setTranslations(null);
      })
      .finally(() => setLoadingTranslations(false));

  }, [propertyId, lang, enabled]);

  return { translations, loadingTranslations };
};

export default usePropertyTranslations;
